export const SET_SCENES = "SET_SCENES";
export const RESET_SCENES = "RESET_SCENES";
export const ADD_SELECTED_SCENE = "ADD_SELECTED_SCENE";
export const REMOVE_SELECTED_SCENE = "REMOVE_SELECTED_SCENE";
export const RESET_SELECTED_SCENE = "RESET_SELECTED_SCENE";
export const SET_SELECTED_SCENE = "SET_SELECTED_SCENE";
export const SET_CLOUD_SCENES = "SET_CLOUD_SCENES";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
